import { Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkModeSubject = new BehaviorSubject<boolean>(this.getSavedTheme());
  isDarkMode$ = this.isDarkModeSubject.asObservable();

  private wasToggledSubject = new BehaviorSubject<boolean>(false); // 🔥 Neu: Observable für Toggle-Status
  wasToggled$ = this.wasToggledSubject.asObservable();
  private wasToggled = false;


  private _id = Math.random().toString(16).slice(2);

  constructor() {
    console.log('ThemeService instance', this._id);
  }

  get id() { return this._id; }

  toggleTheme(): void {
  const newMode = !this.isDarkModeSubject.value;

  this.wasToggled = true;
  this.wasToggledSubject.next(true);

  localStorage.setItem('theme', newMode ? 'dark' : 'light');
  this.isDarkModeSubject.next(newMode);

  setTimeout(() => {
    this.wasToggled = false;
    this.wasToggledSubject.next(false);
  }, 800);
}

  // toggleTheme(): void {
  //   const newMode = !this.isDarkModeSubject.value;
  //   this.isDarkModeSubject.next(newMode);

  //   localStorage.setItem('theme', newMode ? 'dark' : 'light');


  //   this.wasToggled = true;
  //   // this.wasToggledSubject.next(true);
  //   //setTimeout(() => this.wasToggledSubject.next(false), 500);
  //   // 🔥 Erst "true" setzen und dann nach 800ms auf "false" zurücksetzen
  //   this.wasToggledSubject.next(true);
  //   setTimeout(() => {
  //     this.wasToggledSubject.next(false);
  //   }, 800);  // ⏳ Delay entspricht der Animation
  // }

  private getSavedTheme(): boolean {
    const theme = localStorage.getItem('theme');

    if (theme === 'dark') {
      return true;
    }
    return false;
  }

  wasThemeToggled(): boolean {
    return this.wasToggled;
  }

  resetToggleState(): void {
    this.wasToggled = false;
    this.wasToggledSubject.next(false); // 🔥 Zurücksetzen nach Verarbeitung
  }

  setToggleIcons(themeContainer: HTMLElement, darkContainer: HTMLElement, renderer: Renderer2): HTMLElement[] {
    const icons: HTMLElement[] = [];
    const icon1 = themeContainer.querySelector('.toggle-theme i') as HTMLElement;
    const icon2 = darkContainer.querySelector('.toggle-theme i') as HTMLElement;
    if (icon1) icons.push(icon1);
    if (icon2) icons.push(icon2);
    return icons;
  }

  updateImageBasedOnTheme(isDarkMode: boolean, triggeredByToggle: boolean, darkContainer: HTMLElement): void {
    let delayedImageSrc = '';
    // // Bild je nach Theme (Dark/Light) anpassen
    if (!triggeredByToggle) {
      delayedImageSrc = isDarkMode ? 'about-us/hero_sitting_light.webp' : 'about-us/hero_sitting_dark.webp';
      const darkContainerImg = darkContainer.querySelector('.about-img img') as HTMLImageElement;
      if (darkContainerImg) {
        darkContainerImg.src = delayedImageSrc;
      }
    } else {
      setTimeout(() => {
        delayedImageSrc = isDarkMode ? 'about-us/hero_sitting_light.webp' : 'about-us/hero_sitting_dark.webp';
        const darkContainerImg = darkContainer.querySelector('.about-img img') as HTMLImageElement;
        if (darkContainerImg) {
          darkContainerImg.src = delayedImageSrc;
        }
      }, 600);
    }
  }

  updateDarkHomeImage(triggeredByToggle: boolean, darkContainer: HTMLElement): void {
    let delayedImageSrc = '-1';

    if (!triggeredByToggle) {

      delayedImageSrc = this.isDarkModeSubject.value ? 'home/hero_light.webp' : 'home/hero_dark.webp';
      const darkContainerImg = darkContainer.querySelector('.home-img img') as HTMLImageElement;
      if (darkContainerImg) {
        darkContainerImg.src = delayedImageSrc;
      }
    } else {
      setTimeout(() => {
        delayedImageSrc = this.isDarkModeSubject.value ? 'home/hero_light.webp' : 'home/hero_dark.webp';
        const darkContainerImg = darkContainer.querySelector('.home-img img') as HTMLImageElement;
        if (darkContainerImg) {
          darkContainerImg.src = delayedImageSrc;
        }
      }, 800);
    }
  }

  toggleThemeMode(isDarkMode: boolean, renderer: Renderer2, lightContainer: HTMLElement, darkContainer: HTMLElement): void {
    if (isDarkMode) {
      renderer.addClass(darkContainer, 'active');
      renderer.removeClass(lightContainer, 'active');
    } else {
      renderer.removeClass(darkContainer, 'active');
      renderer.addClass(lightContainer, 'active');
    }
  }

  setThemeClasses(renderer: Renderer2, lightContainer: HTMLElement, darkContainer: HTMLElement): void {
    if (!this.wasToggled) {
      if (this.isDarkModeSubject.value) {
        renderer.addClass(darkContainer, 'active-instant');
        renderer.removeClass(lightContainer, 'active-instant');
      } else {
        renderer.removeClass(darkContainer, 'active-instant');
        renderer.addClass(lightContainer, 'active-instant');
      }
    } else {
      if (this.isDarkModeSubject.value) {
        renderer.addClass(darkContainer, 'active');
        renderer.removeClass(lightContainer, 'active');
      } else {
        renderer.removeClass(darkContainer, 'active');
        renderer.addClass(lightContainer, 'active');
      }
    }
  }

}
